import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Box,
  Text,
  VStack,
  Divider,
    useToast,
      IconButton,
        Tooltip,
         Flex,
  useClipboard,
} from "@chakra-ui/react";
import { CopyIcon, CheckIcon } from "@chakra-ui/icons";
import InformativeVerticalProgress from "./InformativeVerticalProgress";
import { buildTimeline } from "../../helpers/timeline";

export default function CategoryDetailDialog({
  isOpen,
  onClose,
  data,
}) {
  if (!data) return null;

function CopyableText({ label, value }) {
  const { hasCopied, onCopy } = useClipboard(value || "");
  const toast = useToast();

  const handleCopy = () => {
    onCopy();

    toast({
      title: "Copied",
      description: `${label} berhasil disalin`,
      status: "success",
      duration: 1500,
      isClosable: true,
    });
  };

  return (
    <Box>
      <Text fontWeight="bold">{label}</Text>

      <Flex align="center" gap="8px">
        <Text>{value || "-"}</Text>

        <Tooltip
          label={hasCopied ? "Copied" : "Copy"}
          hasArrow
        >
          <IconButton
            icon={hasCopied ? <CheckIcon /> : <CopyIcon />}
            size="xs"
            aria-label="Copy"
            onClick={handleCopy}
          />
        </Tooltip>
      </Flex>
    </Box>
  );
}

  const timelineSteps = buildTimeline(data.comments);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Ticket Detail  <b>{data.number_ticket}</b></ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack align="stretch" spacing={4}>
            {/* BASIC INFO */}
            <Box>
              <Text fontWeight="bold">Subject</Text>
              <Text>{data.subject}</Text>
            </Box>

            <Box>
              <CopyableText
                label="Number Ticket"
                value={data.number_ticket}
              />
            </Box>

            <Box>
              <Text fontWeight="bold">Description</Text>
              <Text>{data.description}</Text>
            </Box>

            <Box>
              <Text fontWeight="bold">Category</Text>
              <Text>{data.category?.name}</Text>
            </Box>

            <Box>
              <Text fontWeight="bold">Assigned To</Text>
              <Text>{data.assigned_user?.name ?? "-"}</Text>
            </Box>

            <Divider />

            {/* PROGRESS + ACTIVITY */}
            <Box>
              <Text fontWeight="bold" mb={4}>
                Progress & Activity
              </Text>

              <InformativeVerticalProgress steps={timelineSteps} />
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
